import { render, staticRenderFns } from "./InclusiveNodeConfig.vue?vue&type=template&id=cc604f94&scoped=true"
import script from "./InclusiveNodeConfig.vue?vue&type=script&lang=js"
export * from "./InclusiveNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./InclusiveNodeConfig.vue?vue&type=style&index=0&id=cc604f94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc604f94",
  null
  
)

export default component.exports